import { Link } from "react-router-dom";
import Layout from "./Layout";
import SEOHead from "./SEOHead";

const NotFound = () => {
  return (
    <Layout>
      <SEOHead
        title="Page Not Found | Vasavi Structures"
        description="The page you're looking for doesn't exist. Explore Vasavi Structures' PEB, industrial shed and steel fabrication services."
        noindex
      />
      <section className="section-padding">
        <div className="container-custom text-center max-w-xl">
          <h1 className="font-montserrat text-5xl font-bold text-foreground mb-4">404</h1>
          <p className="text-muted-foreground text-lg mb-8">
            The page you're looking for doesn't exist or may have moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary">Back to Home</Link>
            <Link to="/enquiry" className="btn-outline">Get a Quote</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
